import axios from 'axios'

import type { Manual } from '../types/release.type'

export interface IFetchDoc {
  slug: string
}

export type FetchDocResponse = {
  manual: Manual
}

export const fetchDocService = async ({
  slug,
}: IFetchDoc): Promise<FetchDocResponse> => {
  const response = await axios.get(
    `https://api-plataforma.cnesistemas.com.br/api/manuals/${slug}`,
  )

  return {
    manual: response.data,
  }
}
